!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("classnames")) : "function" == typeof define && define.amd ? define(["react", "classnames"], t) : "object" == typeof exports ? exports["react-imgr-development"] = t(require("react"), require("classnames")) : e["react-imgr-development"] = t(e.react, e.classnames);
}(this, function (e, t) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 5);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    var n = !("undefined" == typeof window || !window.document || !window.document.createElement),
        o = {
      canUseDOM: n,
      canUseWorkers: "undefined" != typeof Worker,
      canUseEventListeners: n && !(!window.addEventListener && !window.attachEvent),
      canUseViewport: n && !!window.screen,
      isInWorker: !n
    };
    e.exports = o;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {},, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        o = r.n(n),
        a = r(2),
        i = r.n(a),
        u = r(1),
        s = r.n(u);

    function l(e) {
      return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function f() {
      "function" == typeof Symbol && l(Symbol.iterator), Object.prototype.hasOwnProperty;
    }

    function p() {
      var e = 0;
      return ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0) + e++).toString();
    }

    function d() {
      var e = {},
          t = void 0,
          r = function r(e) {
        return function (t) {
          t.forEach(function (t) {
            t.isIntersecting && e();
          });
        };
      },
          n = {
        root: void 0,
        rootMargin: "0px 0px 350px 0px",
        threshold: .01
      };

      return t = t || function (e) {
        return new IntersectionObserver(r(e), n);
      }, {
        register: function register(o) {
          var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {
            return e;
          },
              i = arguments[2],
              c = arguments[3];
          if (!o || !s.a.canUseDOM) return null;
          var u = c || i ? function (e, t, o) {
            var a = Object.assign({}, n, {
              root: t,
              rootMargin: "0px 0px " + (o || 350) + "px 0px"
            });
            return new IntersectionObserver(r(e), a);
          }(a, i, c) : t(a);
          u.observe(o);
          var l = Object(p)();
          return e[l] = {
            elem: o,
            observer: u
          }, l;
        },
        unregister: function unregister(t) {
          if (t && s.a.canUseDOM) {
            if (e[t]) {
              var r = e[t].observer;
              r && r.unobserve(e[t].elem);
            }

            delete e[t];
          }
        }
      };
    }

    function m(e, t, r) {
      var n = {},
          o = function o(e) {
        var t = n[e];
        return t || (t = new RegExp("(\\s|^)" + e + "(\\s|$)"), n[e] = t), t;
      };

      function a(e, t) {
        var r = o(t);
        return Boolean(e && e.className && r.test(e.className));
      }

      return {
        i: function i(e, t) {
          var r = o(t);
          return Boolean(e && e.className && r.test(e.className));
        },
        s: function s(e, t) {
          e && !a(e, t) && (e.className += " " + t);
        },
        c: function c(e, t) {
          if (e && a(e, t)) {
            var r = o(t);
            e.className = e.className.replace(r, " ");
          }
        },
        u: function u(e, t) {
          e && (e.className = t);
        },
        l: function l(e) {
          var t = document.getElementById(e);
          t && t.parentNode && t.parentNode.removeChild(t);
        },
        d: function d(e, t, r, n) {
          return function () {
            requestAnimationFrame(function () {
              e && (e.src = r, e.src = t || r, n && c(e, n));
            });
          };
        },
        p: function p(e) {
          return Boolean(!(!1 === e.isTrusted) && (e.screenX && 0 !== e.screenX && e.screenY && 0 !== e.screenY || e.clientX && 0 !== e.clientX && e.clientY && 0 !== e.clientY));
        },
        f: function f(e) {
          var t = new Image();
          return new Promise(function (r, n) {
            function o() {
              t.removeEventListener("load", o), t.removeEventListener("error", a), r(t);
            }

            function a(e) {
              t.removeEventListener("load", o), t.removeEventListener("error", a), n(e);
            }

            t.addEventListener("load", o), t.addEventListener("error", a), t.src = e;
          });
        }
      };
    }

    r(3);

    function g(e) {
      return (g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function y(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function h(e) {
      return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function v(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function b(e, t) {
      return (b = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function I(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    r.d(t, "default", function () {
      return w;
    });

    var w = function (e) {
      function t() {
        var e, r, n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var a = arguments.length, i = new Array(a), c = 0; c < a; c++) {
          i[c] = arguments[c];
        }

        return n = this, o = (e = h(t)).call.apply(e, [this].concat(i)), r = !o || "object" !== g(o) && "function" != typeof o ? v(n) : o, I(v(r), "state", {
          preloadImgLoaded: !1
        }), I(v(r), "enumerable", !0), I(v(r), "configurable", !0), I(v(r), "writable", !0), I(v(r), "onActualImgLoad", function () {
          "function" == typeof r.props.onImageLoad && r.props.onImageLoad(r.actualImgRef);
        }), I(v(r), "onActualImgError", function () {
          "function" == typeof r.props.onImageError && r.props.onImageError(r.actualImgRef);
        }), I(v(r), "onPreloadImageLoad", function () {
          r.preloadImgRef && (r.preloadImgWidth = r.preloadImgRef.width, r.preloadImgHeight = r.preloadImgRef.height, "function" == typeof r.props.onPreImageLoad && r.props.onPreImageLoad(r.preloadImgRef), r.setState({
            preloadImgLoaded: !0
          }));
        }), I(v(r), "setActualImgRef", function (e) {
          r.actualImgRef = e;
        }), I(v(r), "setPreloadImgRef", function (e) {
          r.preloadImgRef = e;
        }), I(v(r), "registerForLazyLoad", function () {
          var e = v(r);

          if (r.actualImgRef && r.preloadImgRef) {
            var t = "progressive-image-loaded";
            r.lazyId = d().register(r.preloadImgRef, function () {
              return e.lazyId && d().unregister(e.lazyId), "function" == typeof e.props.onLazyLoad && e.props.onLazyLoad(), Object(m().d)(e.actualImgRef, e.props.src, e.props.placeholder)();
            }), r.actualImgRef.onload = function (e) {
              window.requestAnimationFrame(function () {
                Object(m().s)(r.actualImgRef, t), r.onActualImgLoad();
              });
            }, r.actualImgRef.onerror = function (e) {
              window.requestAnimationFrame(function () {
                r.actualImgRef.src = r.props.placeholder, Object(m().s)(r.actualImgRef, t), r.onActualImgError();
              });
            };
          }
        }), r;
      }

      var r, a, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && b(e, t);
      }(t, n["Component"]), r = t, (a = [{
        key: "f",
        value: function value(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e, t) {
          return !Object(f)(this.props, e) || !Object(f)(this.state, t);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          Object(f)(this.props, e) || (this.lazyId && d().unregister(this.lazyId), this.registerForLazyLoad());
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.registerForLazyLoad();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.lazyId && d().unregister(this.lazyId);
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t = this.props,
              r = t.src,
              n = t.preloadSrc,
              a = t.containerClassName,
              c = this.state.preloadImgLoaded,
              u = i()((this.f(e = {}, "progressive-img-cont", !0), this.f(e, "scale-width", c && this.props.scale && this.preloadImgWidth >= this.preloadImgHeight), this.f(e, "scale-height", c && this.props.scale && this.preloadImgWidth < this.preloadImgHeight), e), a);
          return o.a.createElement("div", {
            className: u,
            style: this.props.containerStyle
          }, o.a.createElement("img", {
            ref: this.setActualImgRef,
            className: i()("actual-img", this.props.className),
            alt: this.props.alt || ""
          }), o.a.createElement("img", {
            ref: this.setPreloadImgRef,
            className: i()("preload-img", this.f({}, "blur", this.props.initialBlur), this.props.preloadImgClassName),
            src: n || r,
            alt: this.props.alt || "",
            onLoad: this.onPreloadImageLoad
          }));
        }
      }]) && y(r.prototype, a), c && y(r, c), t;
    }();

    w.defaultProps = {
      placeholder: "https://via.placeholder.com/67x83",
      preloadSrc: "https://via.placeholder.com/50x50",
      src: "https://via.placeholder.com/3376x560",
      initialBlur: !0,
      scale: !0,
      containerStyle: {
        width: "100%",
        height: "100%"
      }
    };
  }]);
});